// GDPR consent store — Google Consent Mode v2 bridge.
// Storage shape (localStorage "yanre.consent.v1"):
//   { version: 1, updatedAt: ISO, analytics: bool, advertising: bool }
// The same shape is read pre-GTM by the bootstrap in public/index.html,
// so returning visitors get their choice applied before any tag executes.
export const CONSENT_KEY = "yanre.consent.v1";
export const CONSENT_OPEN_EVENT = "yanre:open-cookie-preferences";

export const readConsent = () => {
  try {
    const v = JSON.parse(localStorage.getItem(CONSENT_KEY) || "null");
    return v && v.version === 1 ? v : null;
  } catch {
    return null;
  }
};

// UI categories → Consent Mode v2 signals (advertising maps to all three ad signals).
const toGcm = ({ analytics, advertising }) => ({
  analytics_storage: analytics ? "granted" : "denied",
  ad_storage: advertising ? "granted" : "denied",
  ad_user_data: advertising ? "granted" : "denied",
  ad_personalization: advertising ? "granted" : "denied",
});

// Every consent change — grant, reject or withdrawal — goes through here.
export const applyConsent = (choices) => {
  const normalized = { analytics: !!choices.analytics, advertising: !!choices.advertising };
  if (typeof window !== "undefined") {
    // Never silently skip: guarantee the command channel exists even if the
    // index.html bootstrap hasn't run (stale cache, script blockers, ordering).
    window.dataLayer = window.dataLayer || [];
    if (typeof window.gtag !== "function") {
      window.gtag = function () { window.dataLayer.push(arguments); };
    }
    window.gtag("consent", "update", toGcm(normalized));
  }
  try {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({ version: 1, updatedAt: new Date().toISOString(), ...normalized })
    );
  } catch {
    // Storage unavailable (private mode): choice still applies for this page.
  }
  return normalized;
};

// Persistent "Cookie Preferences" entry points (footer etc.) open the UI via this event.
export const openCookiePreferences = () =>
  window.dispatchEvent(new CustomEvent(CONSENT_OPEN_EVENT));
